import React from 'react';

import { MenuItem, Paper, TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import Autosuggest from 'react-autosuggest';

function renderInputComponent (inputProps) {
  const { classes, inputRef = () => {}, ref, ...other } = inputProps;

  return (
    <TextField
      fullWidth
      // InputLabelProps={{
      //   shrink: true,
      // }}
      InputProps={{
        inputRef: node => {
          ref(node);
          inputRef(node);
        },
        classes: {
          input: classes.input,
        },
      }}
      {...other}
    />
  );
}

function renderSuggestion (suggestion, { query, isHighlighted }) {
  const matches = match(suggestion.nome, query);
  const parts = parse(suggestion.nome, matches);

  return (
    <MenuItem selected={isHighlighted} component='div'>
      <div>
        {parts.map((part, index) => {
          return part.highlight ? (
            <span key={String(index)} style={{ fontWeight: 500 }}>
              {part.text}
            </span>
          ) : (
            <strong key={String(index)} style={{ fontWeight: 300 }}>
              {part.text}
            </strong>
          );
        })}
      </div>
    </MenuItem>
  );
}

const styles = theme => ({
  root: {
    marginTop: 15,
    height: 60,
    flexGrow: 1,
    marginLeft: theme.spacing(1),
  },
  container: {
    position: 'relative',
  },
  suggestionsContainerOpen: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0,
  },
  suggestion: {
    display: 'block',
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
  },
  divider: {
    height: theme.spacing(2),
  },
});

class IntegrationAutosuggest extends React.Component {
  state = {
    single: this.props.nomeSelected === undefined ? '' : this.props.nomeSelected,
    suggestions: [],
    id: this.props.idSelected === undefined ? 0 : this.props.idSelected,
  };

  getSuggestions (value) {
    const inputValue = value.length !== 0 ? value.trim().toUpperCase() : '';
    const inputLength = inputValue.length;
    let count = 0;

    return inputLength === 0
      ? []
      : this.props.suggestions.filter(suggestion => {
        const regex = new RegExp(inputValue.toUpperCase());
        const keep = count < (this.props.maxSuggestions !== undefined ? this.props.maxSuggestions : 5) && regex.test(suggestion.nome.toUpperCase());

        if (keep) {
          count += 1;
        }

        return keep;
      });
  }

  handleSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.getSuggestions(value),
    });
  }

  handleSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
    if (this.props.handleClear !== undefined){
      this.props.handleClear();
    }
  }

  handleChange = (name) => (event, { newValue }) => {
    let novoValor = newValue._v === undefined ? newValue : newValue._v;
    this.setState({
      [name]: novoValor.toUpperCase(),
    });
    let valor = this.state.suggestions.find(obj => obj.nome === novoValor);
    this.props.getSuggestionValue(novoValor, valor === undefined ? 0 : valor.id, novoValor.toUpperCase());
  }

  handleBlur = () => {
    if (this.props.handleBlur !== undefined) {
      this.props.handleBlur();
    }
  }

  select = event => {
    event.target.select();
  }

  render () {
    const { classes, getSuggestionValue } = this.props;
    const autosuggestProps = {
      renderInputComponent,
      suggestions: this.state.suggestions,
      onSuggestionsFetchRequested: this.handleSuggestionsFetchRequested,
      onSuggestionsClearRequested: this.handleSuggestionsClearRequested,
      getSuggestionValue,
      renderSuggestion,
    };

    return (
      <div className={classes.root}>
        <Autosuggest
          {...autosuggestProps}
          inputProps={{
            classes,
            placeholder: this.props.placeholder,
            label: this.props.label === undefined ? '' : this.props.label,
            disabled: this.props.disabled,
            value: this.state.single,
            onChange: this.handleChange('single', this.state.suggestions),
            onBlur: this.handleBlur,
            type: 'search',
            onFocus: this.select,
          }}
          theme={{
            container: classes.container,
            suggestionsContainerOpen: classes.suggestionsContainerOpen,
            suggestionsList: classes.suggestionsList,
            suggestion: classes.suggestion,
          }}
          renderSuggestionsContainer={options => (
            <Paper {...options.containerProps} square>
              {options.children}
            </Paper>
          )}
        />
      </div>
    );
  }
}

export default withStyles(styles)(IntegrationAutosuggest);
